/* PURCHASES */
export const GET_PURCHASES = "GET_PURCHASES"
export const GET_PURCHASES_SUCCESS = "GET_PURCHASES_SUCCESS"
export const GET_PURCHASES_FAIL = "GET_PURCHASES_FAIL"

/* PURCHASES PROFILE */
export const GET_PURCHASE_PROFILE = "GET_PURCHASE_PROFILE"
export const GET_PURCHASE_PROFILE_SUCCESS = "GET_PURCHASE_PROFILE_SUCCESS"
export const GET_PURCHASE_PROFILE_FAIL = "GET_PURCHASE_PROFILE_FAIL"

/**
 * add PURCHASE
 */
 export const ADD_NEW_PURCHASE = "ADD_NEW_PURCHASE"
 export const ADD_PURCHASE_SUCCESS = "ADD_PURCHASE_SUCCESS"
 export const ADD_PURCHASE_FAIL = "ADD_PURCHASE_FAIL"

 /**
 * Edit PURCHASE
 */
export const UPDATE_PURCHASE = "UPDATE_PURCHASE"
export const UPDATE_PURCHASE_SUCCESS = "UPDATE_PURCHASE_SUCCESS"
export const UPDATE_PURCHASE_FAIL = "UPDATE_PURCHASE_FAIL"

/**
 * Delete PURCHASE
 */
export const DELETE_PURCHASE = "DELETE_PURCHASE"
export const DELETE_PURCHASE_SUCCESS = "DELETE_PURCHASE_SUCCESS"
export const DELETE_PURCHASE_FAIL = "DELETE_PURCHASE_FAIL"


